"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.55 6.59c0-.867.694-1.59 1.575-1.59h1.75c.88 0 1.575.723 1.575 1.59v1.779l-.001.062c-.002 1.524-.072 3.12-.6 4.348-.277.642-.69 1.213-1.303 1.617q-.92.605-2.27.604a.7.7 0 1 1 0-1.4c.69 0 1.163-.152 1.5-.373.336-.222.592-.55.787-1.001.26-.608.387-1.38.444-2.273a2 2 0 0 1-.132.006h-1.75c-.88 0-1.575-.723-1.575-1.59z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ThousandsIcon20.js.map